// import coloredlogo from '../images/coloredlogo.png'
import CainIjegun3Girls from "../images/ProjectsData/CainIjegun3Girls.JPG";
import JeidaDisplayPhoto from "../images/Jeida/JeidaCoverPhoto.jpg";
import ERC from "../images/resource_center/F3.jpg";
import Akaeze from "../images/Akaeze/Akaeze Gallery.png.jpg";
import CAINTUT from "../images/Tutorial/DT3.jpg";
import Christmas from "../images/christmas/IMG4.jpg";
import CareerEnrichment from "../images/Career Enrichment/CEPCover.jpg";
import Mentorship from "../images/Mentorship/Mentorship-6.jpg";
import FoodDrive from "../images/ProjectsData/FoodDriveCover.png";
import CainLibrary from "../images/Library/Lib1.jpg";
import ICT from "../images/ProjectsData/ICT4UCover.jpg";

const ProjectData = [
  {
    index: 1, //These should be incremental from the last interger
    title: "ICT4U (ICT for Underserved Students)",
    image: `${ICT}`,
    description:
      "By 2030, 230 million jobs in Sub-Saharan Africa will require digital skills. Shockingly, over 60% of African students currently lack basic digital training, and only 50% of African countries include 'computer' skills in their school curriculum. These alarming statistics highlight a significant digital skills shortage, necessitating urgent action. This led to the launch of the ICT4U Program...",
    status: "Ongoing",
    link: "/projects/ict4u",
  },
  {
    index: 2, 
    title: "ARISE (Allocating Resources to Improve School Experience)",
    image: `${CainIjegun3Girls}`,
    description:
      "Over 1,500 children at Ijegun Community Primary School 1 have had their learning experiences transformed by the ARISE project. The school has received about 200 textbooks in the major subjects of Mathematics and English. CAIN Educational Foundation has been successful in providing these students with a stronger foundation in both subjects.",
    status: "Completed",
    link: "/projects/project-arise",
  },
  {
    index: 3,
    title: "Community Development For Jeida Village",
    image: `${JeidaDisplayPhoto}`,
    description:
      "Ensuring that underprivileged communities in Africa have access to adequate healthcare services will continue to be our top concern and it remains one of the two pillars of the CAIN Education Foundation. Kelechi Umoga, a Yale University medical student, in collaboration with CAIN Education Foundation.",
    status: "Completed",
    link: "/projects/Project-BtG",
  },
  {
    index: 4,
    title: "CAIN Educational Resource Center",
    image: `${ERC}`,
    description:
      "The CAIN Educational Resource Centre in Ikotun, Lagos, was established as a result of our resolve to provide a long-term solution to the void in quality education that plagues underprivileged communities. By establishing this facility, we will be able to provide effective educational resources that will promote intellectual development, self-reliance and socioeconomic growth.",
    status: "Ongoing",
    link: "/projects/Project-CAINERC",
  },
  {
    index: 5,
    title: "CAIN Daily Tutorial Program",
    image: `${CAINTUT}`,
    description:
      "The CAIN Daily Tutorial Program is one of the key areas of intervention of the CAIN Scholars' Program, which aims to help children from low-income families in the Ikotun/Igando Local Government Area gain access to high-quality educational resources, introduce them to educational enhancement programs, and equip them with the skills...",
    status: "Ongoing",
    link: "/projects/Project-CAINSP2017",
  },
  {
    index: 6,
    title: "Akaeze Summer Program",
    image: `${Akaeze}`,
    description:
      "The Akaeze Summer Program is designed to encourage students to build a reading habit as well as critical thinking and communication abilities. Reading, discussions, vocabulary development and essay writing are the four main pillars of this program. The first edition of this program took place at CAIN Educational Resource Centre.",
    status: "Completed",
    link: "/projects/Akaeze-Summer-Program",
  },
  {
    index: 7,
    title: "Christmas Benevolence Project ",
    image: `${Christmas}`,
    description:
      "This effort arose from our desire to assist and support the community's less privileged people over the Christmas holiday season. It's a CAIN Educational Foundation charity initiative aimed at providing food and other gifts to destitute families during the Christmas season. The first edition of this program, dubbed 'The 50/50 Campaign'...",
    status: "Completed",
    link: "/projects/Christmas-Benevolence-Project",
  },
  {
    index: 8,
    title: "Career Enrichment Program",
    image: `${CareerEnrichment}`,
    description:
      "The CAIN Career Enrichment Program is a monthly developmental program created to assist over 1,000 underprivileged students in making informed educational and career choices. We believe all individuals should be empowered to choose a meaningful career and education pathway to position themselves for lifelong success.",
    status: "Ongoing",
    link: "/projects/career-enrichment-program",
  },
  {
     index: 9,
     title: "Mentorship Program",
     image: `${Mentorship}`,
     description:
       "In underserved African communities, many students grow up surrounded by the limitations of poverty, lack of exposure, and minimal access to role models who can help shape their vision of what’s possible. At CAIN Africa, we believe mentorship is one of the most powerful tools to...",
      status: "Ongoing",
      link: "/projects/mentorship",
  },
  {
    index: 10,
    title: "Monthly Food Drive: Feeding Underprivileged Families",
    image: `${FoodDrive}`,
    description:
      "As part of our unwavering commitment to supporting underprivileged communities, we organize a monthly food drive aimed at alleviating hunger among those struggling to make ends meet. Currently, we are partnered with Sandra Duke Catering, a reputable catering service that shares our vision of providing relief to those in need. Since the inception of the program...",
    status: "Ongoing",
    link: "/projects/monthly-food-drive",
  },
  {
    index: 11,
    title: "The CAIN Library Initiative",
    image: `${CainLibrary}`,
    description:
      "A library is an invaluable resource for students, offering access to a vast array of information and educational materials essential for research, study, and completing assignments. However, many underprivileged students lack access to libraries, as their schools often do not have such facilities, and their homes are typically not conducive to learning.",
    status: "Ongoing",
    link: "/projects/project-library",
  },
];

export default ProjectData;
